import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, Validators } from '@angular/forms';
import { ConfirmationToastComponent } from '../../../components/confirmation-toast/confirmation-toast.component';
import { AssessmentService } from 'src/app/services/assessment.service';
import { DialogService } from 'src/app/services/dialog.service';
import { ReportService } from 'src/app/services/report.service';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';


@Component({
    selector: 'app-report-manipulation',
    templateUrl: './report-manipulation.component.html',
    styleUrl: './report-manipulation.component.scss',
    standalone: false
})
export class ReportManipulationComponent {
  
  lastCheckedID: any = "";
  report: any = null

  authorizationStatusList = [
    'SIGNATURE REQUESTED - FOLO',
    'SIGNATURE REQUESTED - ROLO',
    'SIGNATURE REQUESTED - WO',
    'REVIEW RO FUNDING',
    'RO FUNDING AUTHORIZED',
    'REVIEW WO FUNDING',
    'FUNDING AUTHORIZED',
    'COMPLETED - NO FUNDING',
  ]

  reportStatusList = [
    "IN PROGRESS",
    "READY FOR SUBMISSION",
    "SUBMITTED",
    "IN REVIEW",
    "SIGNATURE REQUESTED",
    "READY FOR FUNDING RECOMMENDATIONS",
    "REGIONAL FUNDS APPROVED",
    "FUNDING APPROVED",
  ]

  pageStatusList = [
    "Not Started",
    "Partial",
    "Complete",
  ]

  pageNumber = [
    "page_1_status_id",
    "page_2_status_id",
    "page_3_status_id",
    "page_4_status_id",
    "page_5_status_id",
    "page_6_status_id",
    "page_7_status_id",
    "page_8_status_id",
  ]

  userForm = this.formBuilder.group({
    report_id: ["", Validators.min(0)],
    authorization_status_id: [-1],
    report_status_id: [-1],
    page_1_status_id: [-1],
    page_2_status_id: [-1],
    page_3_status_id: [-1],
    page_4_status_id: [-1],
    page_5_status_id: [-1],
    page_6_status_id: [-1],
    page_7_status_id: [-1],
    page_8_status_id: [-1],
  });

  constructor(
    public dialogRef: MatDialogRef<ReportManipulationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private readonly formBuilder: FormBuilder,
    private readonly assessmentService: AssessmentService,
    private readonly toast: ConfirmationToastComponent,   
    public readonly dialogService: DialogService,    
    private readonly reportService: ReportService,
  ) {
  }


  loadReport() {
    this.userForm.patchValue({
      authorization_status_id: this.report.authorization_status_id,
      report_status_id: this.report.report_status_id,
      page_1_status_id: this.report.page_1_status_id,
      page_2_status_id: this.report.page_2_status_id,
      page_3_status_id: this.report.page_3_status_id,
      page_4_status_id: this.report.page_4_status_id,
      page_5_status_id: this.report.page_5_status_id,
      page_6_status_id: this.report.page_6_status_id,
      page_7_status_id: this.report.page_7_status_id,
      page_8_status_id: this.report.page_8_status_id,
    })
    //this.getReport(this.report.report_id)
  }

  checkIfReportExists(): void {
    if (this.userForm.controls.report_id.errors) {
      this.userForm.controls.report_id.setErrors({ "pattern": this.userForm.controls.report_id.errors })
      return
    }
    let report_id = this.userForm.value.report_id as any as number
    if (this.lastCheckedID == report_id) return // Prevent double event firing
    this.lastCheckedID = report_id
    if (report_id == null) {
      return
    }
    this.dialogService.openSpinner();
    this.reportService.getReport(report_id, ["signatures"]).subscribe({
      next: (response) => {
        this.dialogService.closeSpinner();
        if (response.totalResults > 0) {
          this.report = response.reports[0];
          this.loadReport();
        } else {
          // no report found
        }
      },
      error: (response) => {
        this.dialogService.closeSpinner();
      },
      complete: () => {
      }
    })
  }

  saveReport() {
    this.reportService.updateReport({
      report_id: Number(this.userForm.value.report_id),
      authorization_status_id: this.userForm.value.authorization_status_id as number,
      report_status_id: this.userForm.value.report_status_id as number,
      page_1_status_id: this.userForm.value.page_1_status_id as number,
      page_2_status_id: this.userForm.value.page_2_status_id as number,
      page_3_status_id: this.userForm.value.page_3_status_id as number,
      page_4_status_id: this.userForm.value.page_4_status_id as number,
      page_5_status_id: this.userForm.value.page_5_status_id as number,
      page_6_status_id: this.userForm.value.page_6_status_id as number,
      page_7_status_id: this.userForm.value.page_7_status_id as number,
      page_8_status_id: this.userForm.value.page_8_status_id as number,
      regional_funding_status_id: 0,
      regional_approval_status_id: 0,
      wo_funding_status_id: 0,
      wo_approval_status_id: 0,
      report_num: this.report.report_num,
    }).subscribe({
      next: (response) => {
        this.toast.openSuccessSnackBar("Report Successfully Saved")
        this.dialogRef.close();
      },
      error: (response) => {
        this.toast.openErrorSnackBar(`There was an error saving the report`, "Please try again.");
      },
    })
  }

  /**
   * Conccurent calls so it can be faster
   */
  getReport(report_id: number) {

    this.dialogService.openSpinner();
    let report: any = {}
    let promise1 = new Promise((resolve, reject) => {
      this.reportService.getReport(report_id, ["forests", "forests.treatments", "forests.treatments.treatment_specifications", "forests.line_officer"]).subscribe({
        next: (response: any) => {
          let r = response.reports[0]
          report.forests = r.forests
          resolve(null)
        },
        error: (err) => {        
          reject(new Error(err))
        },
      });
    })
    let promise2 = new Promise((resolve, reject) => {
      this.reportService.getReport(report_id, ["users", "users.user", "users.skills.skill", "signatures"]).subscribe({
        next: (response: any) => {
          let r = response.reports[0]
          report.users = r.users
          report.signatures = r.signatures
          resolve(null)
        },
        error: (err) => {        
          reject(new Error(err))
        },
      });
    })
    let promise3 = new Promise((resolve, reject) => {
      this.reportService.getReport(report_id, ["assessment", "stateCounties", "supporting_files", "watersheds", "soil_burn_severities"]).subscribe({
        next: (response: any) => {
          let r = response.reports[0]
          for (let field in r) {
            report[field] = r[field]
          }
          resolve(null)
        },
        error: (err) => {        
          reject(new Error(err))
        },
      });
    })
    Promise.all([promise1, promise2, promise3]).then((result) => {
        this.dialogService.closeSpinner()
        this.cleanReport(report)
    }).catch((error: any) => {
      this.dialogService.closeSpinner()
      this.toast.openErrorSnackBar(`There was an error loading the report.`, "Please refresh to try again.");
    })
  }

  iter(o: any, parent: ReportManipulationComponent) {
    Object.keys(o).forEach(function (k) {
        if (['report_id','forest_id',"line_officer","treatments","geo_area_choice","report_signature_id","report_soil_burn_severity_id","state_id","supporting_files",'file_link','users','watershed_id'].includes(k)) {
            delete o[k]
            return
        }
        if (o[k] !== null && typeof o[k] === 'object') {
            parent.iter(o[k], parent);
            return;
        }
        // if (k == "line_officer") {
        //   o.line_officer_id = o[k].line_officer_id
        // }
    });
  }

  convertDate(date: string): string {
    return `${date.substring(5,7)}/${date.substring(8,10)}/${date.substring(0,4)}`
  }

  cleanReport(report: any) {
    report.assessment_id = report.assessment.assessment_id
    delete report.assessment
    report.containment_date = this.convertDate(report.containment_date)
    report.containment_date_est = this.convertDate(report.containment_date_est)
    report.fire_discovery_date = this.convertDate(report.fire_discovery_date)
    report.submission_date = this.convertDate(report.submission_date)

    this.iter(report, this)
    console.log("new report", report)
    this.reportService.createReportEverything(report).subscribe({
      next: (response) => {
        this.toast.openSuccessSnackBar(`An initial report for  has been created.`);
      },
      error: (response) => {
        this.toast.openErrorSnackBar(`There was an error creating the initial report.`, "Please try again.");
      },
    });
  }

  deleteAllSignatures() {
    this.report.signatures.forEach((signature: any) => {
      this.deleteSignature(signature);
    })
  }

  deleteSignature(signature: any) {
    this.reportService.deleteSignature(signature.report_signature_id).subscribe({
      next: (response) => {
        this.toast.openSuccessSnackBar(`Signature Deleted.`);
      },
      error: (response) => {
        this.toast.openErrorSnackBar(`Signature deleted fail.`, "Please try again.");
      },
    });
  }
}